class TouchManger {
  constructor(initiator) {
    this.initiator = initiator;

    this.touchStartHandler = (event) => { this.down(event); };
  }

  addEvents() {
    this.initiator.DOMElement.addEventListener('touchstart', this.touchStartHandler);
  }

  removeEvents() {
    this.initiator.DOMElement.removeEventListener('touchstart', this.touchStartHandler);
  }

  down() {
    this.initiator.action();
  }
}

export default TouchManger;
